export const programsQuery = `
  *[_type == "program"] | order(order asc) {
    _id,
    title,
    description,
    image
  }
`;

export const reasonsQuery = `
  *[_type == "reasonsSection"][0]{
    subtitle,
    title,
    showClip,
    clipLines,
    "carouselImages": carouselImages[].asset->url,
    reasons[] {
      text,
      "icon": icon.asset->url
    }
  }
`;

export const teamQuery = `
*[_type == "teamSection"][0]{
  titleParts,
  members[]->{
    name,
    belt,
    image {
      asset->{
        url
      }
    }
  }
}
`;

export const scheduleQuery = `
*[_type == "scheduleSection"][0]{
  title,
  days[]{
    day,
    sessions[]{
      start { hour, minute },
      end { hour, minute },
      trainer->{ name },
      location->{ name },
      programs[]->{ title }
    }
  }
}
`;

export const testimonialsQuery = `
  *[_type == "testimonialsSection"][0]{
    isVisible,
    title,
    subtitle,
    testimonials[]{
      review,
      name,
      status,
      image
    }
  }
`;

export const contactQuery = `
  *[_type == "contactSection"][0]{
    title,
    subtitle,
    description,
    programOptions,
    submitText,
    successMessage,
    errorMessage
  }
`;

export const locationsQuery = `
  *[_type == "locations"] | order(name asc) {
    _id,
    name,
    instructor,
    address,
    phone,
    city,
    mapEmbedUrl,
    directionsUrl,
    image
  }
`;

export const brandsQuery = `
  *[_type == "brandsSection"][0].brands
`;

export const footerQuery = `
  *[_type == "footer"][0]{
    logo,
    socials[]{
      name,
      url,
      enabled,
      icon
    },
    whatsapp{
      enabled,
      phone
    }
  }
`;
